module.exports = __webpack_public_path__ + "img/176.7409ef3c.svg";